<div class="grid">
    <div class="col-12">
        <div class="card">
            <h4>Editar Franquia - {{ administradora?.nomeFantasia }}</h4>
            <form *ngIf="administradora" #f="ngForm" name="form">
                <p-tabView styleClass="tabview-custom" (onChange)="abaSelecionada($event)">
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <i class="pi pi-list mr-1"></i>
                            <span>Dados Básicos</span>
                        </ng-template>
                        <div class="formgroup">
                            <div class="p-fluid p-formgrid grid">
                                <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                                    <p-messages
                                        [(value)]="messages"
                                        [enableService]="false"
                                        [closable]="true"
                                    ></p-messages>
                                </div>
                                <div class="col-12 md:col-12">
                                    <h5>Dados Principais</h5>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label htmlFor="nomeFantasia">Nome Franquia</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        type="text"
                                        pInputText
                                        [(ngModel)]="administradora.nomeFantasia"
                                        placeholder="Digite o nome da Franquia"
                                        name="nomeFantasia"
                                        ngModel
                                        #nomeFantasia="ngModel"
                                        required
                                    />
                                </div>
                                <div class="field col-12 md:col-5">
                                    <label htmlFor="razaoSocial">Razão Social*</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        type="text"
                                        pInputText
                                        [(ngModel)]="administradora.razaoSocial"
                                        placeholder="Digite a Razão Social"
                                        name="razaoSocial"
                                        ngModel
                                        #razaoSocial="ngModel"
                                        required
                                    />
                                    <div
                                        *ngIf="
                                            razaoSocial.hasError('required') && razaoSocial.touched
                                        "
                                        class="alerta"
                                    >
                                        <small>Campo obrigatório</small>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label htmlFor="cnpj">CNPJ</label>
                                    <p-inputMask
                                        mask="99.999.999/9999-99"
                                        [unmask]="true"
                                        type="text"
                                        [(ngModel)]="administradora.cnpj"
                                        placeholder="00.000.000/0000-00"
                                        name="cnpj"
                                        ngModel
                                        #cnpj="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-4">
                                    <label htmlFor="email">E-mail</label>
                                    <input
                                        pInputText
                                        type="email"
                                        placeholder="seuemail@mail.com"
                                        name="email"
                                        ngModel
                                        [(ngModel)]="administradora.email"
                                        email="true"
                                        #email="ngModel"
                                    />
                                    <div *ngIf="email.hasError('email')" class="alerta">
                                        <small>Digite um e-mail válido</small>
                                    </div>
                                </div>

                                <div class="col-12 md:col-12">
                                    <h5>Endereço</h5>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="cep">CEP</label>
                                    <p-inputMask
                                        mask="99999-999"
                                        [unmask]="true"
                                        placeholder="00000-000"
                                        name="cep"
                                        ngModel
                                        [(ngModel)]="administradora.cep"
                                        #cep="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-6">
                                    <label htmlFor="logradouro">Logradouro</label>
                                    <input
                                        #inputLogradouro
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="logradouro"
                                        ngModel
                                        #logradouro="ngModel"
                                        [(ngModel)]="administradora.logradouro"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="bairro">Bairro</label>
                                    <input
                                        pInputText
                                        type="text"
                                        name="bairro"
                                        ngModel
                                        oninput="this.value = this.value.toUpperCase();"
                                        [(ngModel)]="administradora.bairro"
                                        #bairro="ngModel"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="numero">Número</label>
                                    <input
                                        pInputText
                                        type="text"
                                        name="numero"
                                        ngModel
                                        #numero="ngModel"
                                        [(ngModel)]="administradora.numero"
                                    />
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="complemento">Complemento</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="complemento"
                                        ngModel
                                        #complemento="ngModel"
                                        [(ngModel)]="administradora.complemento"
                                    />
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="uf">UF</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="uf"
                                        ngModel
                                        #uf="ngModel"
                                        [(ngModel)]="administradora.uf"
                                    />
                                </div>

                                <div class="field col-12 md:col-7">
                                    <label htmlFor="cidade">Cidade</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="cidade"
                                        ngModel
                                        #cidade="ngModel"
                                        [(ngModel)]="administradora.cidade"
                                    />
                                </div>

                                <div class="col-12 md:col-12">
                                    <h5>Contatos</h5>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label htmlFor="telefone">Telefone</label>
                                    <p-inputMask
                                        mask="(99)9999-9999"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="(00)0000-0000"
                                        [(ngModel)]="administradora.telefone"
                                        name="telefone"
                                        ngModel
                                        #telefone="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label htmlFor="whatsapp">Whatsapp</label>
                                    <p-inputMask
                                        mask="(99)99999-9999"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="(00)00000-0000"
                                        [(ngModel)]="administradora.whatsapp"
                                        name="whatsapp"
                                        ngModel
                                        #whatsapp="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="col-12 md:col-12">
                                    <h5>Status</h5>
                                </div>

                                <div class="field col-12 md:col-1">
                                    <label for="desconto">Ativo</label>
                                    <br />
                                    <p-inputSwitch
                                        name="desconto"
                                        [(ngModel)]="administradora.ativo"
                                    ></p-inputSwitch>
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid grid justify-content-between">
                                <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
                                    <button
                                        type="button"
                                        pButton
                                        icon="pi pi-check"
                                        label="Atualizar"
                                        class="p-button-success mt-5"
                                        (click)="atualizar()"
                                    ></button>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
                                    <button
                                        type="submit"
                                        pButton
                                        icon="pi pi-spin pi-spinner"
                                        label="Atualizando..."
                                        class="p-button-success mt-5"
                                        [disabled]="true"
                                    ></button>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <button
                                        type="button"
                                        pButton
                                        icon="pi pi-arrow-left"
                                        label="Voltar"
                                        class="p-button-primary mt-5"
                                        routerLink="/rfarias/administradora"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Usuários">
                        <ng-template pTemplate="header">
                            <i class="pi pi-user mr-1"></i>
                            <span>Usuários</span>
                        </ng-template>
                        <ng-template pTemplate="context">
                            <div
                                class="p-fluid p-formgrid grid"
                                *ngIf="eventoAbaUsuario == 'LISTAR'"
                            >
                                <div class="field col-12 md:col-2">
                                    <button
                                        pButton
                                        pRipple
                                        label="Novo"
                                        (click)="inserirUsuario()"
                                        icon="pi pi-plus"
                                        class="p-button-info mr-2 mb-2"
                                    ></button>
                                </div>
                            </div>
                            <app-usuario-franquia-rfarias-listar
                                *ngIf="eventoAbaUsuario == 'LISTAR'"
                                [administradora]="administradora"
                                (emissor)="trocarComponenteUsuario($event)"
                            ></app-usuario-franquia-rfarias-listar>
                            <app-usuario-franquia-rfarias-inserir
                                *ngIf="eventoAbaUsuario == 'INSERIR'"
                                [administradora]="administradora"
                                (emissor)="trocarComponenteUsuario($event)"
                            ></app-usuario-franquia-rfarias-inserir>

                            <app-usuario-franquia-rfarias-editar
                                *ngIf="eventoAbaUsuario == 'EDITAR'"
                                [id]="idUsuarioFranquia"
                                [administradora]="administradora"
                                (emissor)="trocarComponenteUsuario($event)"
                            ></app-usuario-franquia-rfarias-editar>
                            <app-usuario-franquia-rfarias-detalhar
                                *ngIf="eventoAbaUsuario == 'DETALHAR'"
                                [id]="idUsuarioFranquia"
                                [administradora]="administradora"
                                (emissor)="trocarComponenteUsuario($event)"
                            ></app-usuario-franquia-rfarias-detalhar>
                        </ng-template>
                    </p-tabPanel>
                </p-tabView>
                <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
            </form>
        </div>
    </div>
</div>
